export default __webpack_public_path__ + "static/media/A_arte_de_brincar_5.04afdff6.jpg";